import React from "react";
import Section from "../components/elements/Section";

export default function Footer() {
    return (
        <Section as="footer" className="mc-footer">© 2025 Asimple</Section>
    )
}